import { render, staticRenderFns } from "./StartupsByYearChart.vue?vue&type=template&id=88e93890&"
import script from "./StartupsByYearChart.vue?vue&type=script&lang=js&"
export * from "./StartupsByYearChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports